import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

export const CONTACT_ORGANISATIONS_INDEX_QUERY = gql`
  query contactOrganizations(
    $id: ID!
    $role: [ContactOrganizationRole!] = [admin, manager, member, delivery_contact, accounting]
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
  ) {
    contactOrganizations(
      id: $id
      role: $role
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
    ) {
      nodes {
        id
        name
        parentableId
        parentableType
        role
      }
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`
